import React, { useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import DataSelectionModal from './DataSelectionModal.jsx';

const LinkAccountModal = ({ isOpen, onClose, onSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [checkData, setCheckData] = useState(null);
    const [showDataSelection, setShowDataSelection] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const initData = window.Telegram?.WebApp?.initData;
            if (!initData) {
                setError('Откройте профиль внутри Telegram для привязки аккаунта.');
                setIsLoading(false);
                return;
            }

            const response = await axiosInstance.post('/auth/link-web/check', {
                initData,
                username,
                password
            });

            if (response.data && response.data.success && response.data.canLink) {
                setCheckData(response.data);
                setShowDataSelection(true);
            } else {
                setError(response.data?.error || 'Не удалось проверить аккаунт');
            }
        } catch (err) {
            console.error('Link check error:', err);
            setError(err.response?.data?.error || 'Ошибка при проверке аккаунта');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDataSelectionClose = () => {
        setShowDataSelection(false);
        setCheckData(null);
        onClose();
    };

    const handleDataSelectionSuccess = () => {
        setShowDataSelection(false);
        setCheckData(null);
        onSuccess();
    };

    if (showDataSelection && checkData) {
        return (
            <DataSelectionModal
                isOpen={true}
                onClose={handleDataSelectionClose}
                onSuccess={handleDataSelectionSuccess}
                checkData={checkData}
                username={username}
                password={password}
            />
        );
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Связать веб-аккаунт</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor="username">Логин</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                disabled={isLoading}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Пароль</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={isLoading}
                            />
                        </div>
                        {error && <div className="error-message">{error}</div>}
                    </div>
                    <div className="modal-actions">
                        <div className="actions-group">
                            <button
                                type="submit"
                                className="primary-action"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Проверка...' : 'Продолжить'}
                            </button>
                            <button
                                type="button"
                                className="ghost-action"
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                Отмена
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LinkAccountModal;

